/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Memory_Delete_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not delete this. Please try again." |
*
* @param {Uno_Memory_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_memory_delete_error = /** @type {((inputs?: Uno_Memory_Delete_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Memory_Delete_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konnte nicht gelöscht werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Could not delete this. Please try again.")
});